import { createFullSocket } from '@svs/nova-core/socket';

import type { ISocketService } from '../../domain/entry.js';

/**
 * Socket client service.
 *
 * @returns Socket client service.
 */
export function socketService(): ISocketService {
  let client: ReturnType<ISocketService['getClient']> | undefined;

  const getClient: ISocketService['getClient'] = () => {
    if (!client) {
      client = createFullSocket();
    }

    return client;
  };

  return { getClient };
}
